import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { isEmailValid } from '$shared/helpers/utils';

export class EmailValidator {
  static validate(value: string): void {
    if (!value || isEmailValid(value)) return;

    throw new Error(UIErrorMessage.InvalidEmail);
  }
}
